<template>
    <CCol v-bind="$attrs">
        <ValidationProvider
            tag="div"
            :vid="vid"
            :name="name"
            :rules="rules"
            v-slot="{ errors }"
        >
            <div role="group" class="form-group datepicker">
                {{ autoLabel }}<span v-if="required" class="text-danger">*</span>
                <datePicker
                    :clearable="clearable"
                    :format="format"
                    :display-format="displayFormat"
                    input-class="form-control"
                    :type="type"
                    :value="value"
                    @input="emitInput"
                />
                <span class="invalid-feedback d-block">{{ errors[0] }}</span>
            </div>
        </ValidationProvider>
    </CCol>
</template>

<script>
import { DefaultInputProps } from './defaultProps'

export default {
    name: 'CCustomInput',
    props: {
        ...DefaultInputProps,
        clearable: {default: false},
        format: {default: 'YYYY-MM-DD HH:mm:ss'},
        displayFormat: {default: 'dddd jDD jMMMM jYYYY'},
        type: {default: 'datetime'},
    },
    computed: {
        direction() {
            return this.ltr ? 'ltr' : 'rtl';
        },
        autoLabel() {
            return this.label === '' ? this.name : this.label
        }
    },
    methods: {
        emitInput(value) {
            this.$emit('input', value)
        },
    },
}
</script>